import { GetAssignmentHistoryLayerListResponse } from '@/services';

import { formatDate, map, showDataGridWithSymbol } from 'utils';

export const formatWorkHistoryLayerDetail = (
	input: GetAssignmentHistoryLayerListResponse[number],
	index: number
) => {
	return {
		id: index,
		workplace: input?.franchiseName || '-',
		period: showDataGridWithSymbol(
			formatDate(input?.workStartDate),
			formatDate(input?.workEndDate),
			'~'
		),
		note: input?.memo || '-',
	};
};

export const formatWorkHistoryLayerList = (
	input: GetAssignmentHistoryLayerListResponse
) => {
	return map(input, (item, index) => formatWorkHistoryLayerDetail(item, index));
};
